import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { BaseHouseRelationComponent } from "../base-house-relation/base-house-relation.component";

@Component({
  selector: "host-onboarding-house-relation",
  templateUrl: "./onboarding-house-relation.component.html",
  styleUrls: ["./onboarding-house-relation.component.scss"],
})
export class OnboardingHouseRelationComponent implements OnInit {
  @ViewChild("base") base: BaseHouseRelationComponent;
  @Output() onTypeTabChange = new EventEmitter();
  @Output() onLink = new EventEmitter();
  @Output() onUnlink = new EventEmitter();

  get hasLinkedProperties() {
    return (
      this.base?.leftCMP?.listOfHostexHouses.some((p) => p.card.length) ||
      this.base?.leftCMP?.listOfHostexHouseTypes.some((p) => p.card.length)
    );
  }

  constructor() {}

  ngOnInit() {}
}
